import { Redirect, Route, Switch } from 'react-router';
import { ReactElement, useEffect, useState } from 'react';
import authProvider from '../helpers/authProvider';
import MagicLinkPage from './MagicLinkPage';
import SessionExpiredPage from './SessionExpiredPage';
import ResendLinkPage from './ResendLinkPage';
import { resendLinkPath } from '../helpers/paths';

export default function Auth(props: { children: ReactElement }) {
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
	const [lastEmail, setLastEmail] = useState<string | nundefined>(null);
	const [initializing, setInitializing] = useState<boolean>(true);
	
	useEffect(() => {
		authProvider.initialize();
		
		setInitializing(false);
		
		setIsAuthenticated(authProvider.isAuthenticated());
		setLastEmail(authProvider.getLastEmail());
		
		const deRegistrations: (() => void)[] = [];
		
		deRegistrations.push(authProvider.addAuthChangedListener((isAuthenticated1) => {
			setIsAuthenticated(isAuthenticated1);
		}));

		deRegistrations.push(authProvider.addLastEmailChangedListener((lastEmail1) => {
			setLastEmail(lastEmail1);
		}));
		
		return () => {
			deRegistrations.forEach(cb => cb());
		};
	}, []);
	
	if (initializing) {
		return null;
	}
	
	return (
		<Switch>
			<Route path="/magic-link">
				{isAuthenticated ? <Redirect to="/" /> : <MagicLinkPage />}
			</Route>
			
			<Route path={resendLinkPath}>
				<ResendLinkPage />
			</Route>

			<Route path="*">
				{isAuthenticated ? props.children : lastEmail ? <SessionExpiredPage email={lastEmail} /> : <ResendLinkPage />}
			</Route>
		</Switch>
	)
}